<template>
  <div class="MapBox">
    <div id="allmap"></div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../../../../router";
import { mapGetters } from "vuex";
import { BMPGL } from "@/util/bmpgl.js";
import { selectCompanyMachiner } from "@/api/njdd.js";
import { offsetLocation } from "../../../../../js/utils/util";
import orderInfoWindow from "./orderInfoWindow.vue";
export default {
  props: ["count"],
  data() {
    return {
      ak: window.global.bmKey, //百度地图key
      BMapGL: null, //地图实例
      map: null, //地图实例
      zoom: window.global.view.zoom, //缩放级别
      lon: window.global.view.center[0], //经度
      lat: window.global.view.center[1], //纬度
      markers: [], //坐标点集合
      // eslint-disable-next-line no-undef
      icon: require("../../../../../assets/农机.png"), //农机图标
      // eslint-disable-next-line no-undef
      icon1: require("../../../../../assets/地块.png"), //托管单图标(工作中)
      icon3: require("../../../../../assets/地块2.png"), //托管单图标(空闲中)
      icon2: require("../../../../../assets/自营工作.png"), //自营土地图标(工作中)
      icon4: require("../../../../../assets/自营空闲.png"), //自营土地图标(空闲中)
      machinerVoList: [], //机手信息列表(全部机手)
      machinerVoList1: [], //机手信息列表（工作中）
      ldtpOrders: [], //托管单信息列表
      xmxxList: [], //自营土地列表
      currentInfoWindow: null, //气泡实例
    };
  },
  computed: {
    ...mapGetters(["topSelectAreacode", "topSelectAreaname", "identityObj"]),
  },
  watch: {
    count(e) {
      console.log("count执行", e);
      this.map.closeInfoWindow(this.currentInfoWindow);
      (this.machinerVoList = []), (this.ldtpOrders = []), (this.xmxxList = []);
      this.getOperatorList();
    },
  },
  mounted() {
    console.log("挂载");
    this.initMap();
    this.markers = [];
    this.getOperatorList();
  },

  methods: {
    initMap() {
      BMPGL(this.ak)
        .then((BMapGL) => {
          console.log("地图初始化", BMapGL);
          let map = new BMapGL.Map("allmap");
          let point = new BMapGL.Point(this.lon, this.lat);
          map.setMapType(BMAP_SATELLITE_MAP); //设置地图类型
          var styleJson = [
            {
              featureType: "transit", // 例如，隐藏公交站
              elementType: "labels",
              stylers: {
                visibility: "off",
              },
            },
            // 隐藏商业区域标签
            {
              featureType: "poi",
              elementType: "labels",
              stylers: { visibility: "off" },
            },
            // 隐藏水系标签
            {
              featureType: "water",
              elementType: "labels",
              stylers: { visibility: "off" },
            },
            // 隐藏道路标签（路标）
            {
              featureType: "road.label",
              elementType: "labels",
              stylers: {
                visibility: "off",
              },
            },
            // 隐藏植被区域（树林）
            {
              featureType: "vegetation",
              elementType: "all",
              stylers: {
                visibility: "off",
              },
            },
          ];
          // 应用自定义样式
          map.setMapStyleV2({ styleJson: styleJson }); // 应用自定义样式
          // 初始化地图，设置中心点坐标和地图级别
          map.centerAndZoom(point, this.zoom);
          //开启鼠标滚轮缩放
          map.enableScrollWheelZoom(true);
          // 添加缩放控件
          var zoomCtrl = new BMapGL.ZoomControl();
          map.addControl(zoomCtrl);
          map.setMaxZoom(17);
          //保存数据
          this.map = map;
          this.BMapGL = BMapGL;
        })
        .catch((err) => { });
    },
    //获取数据列表
    async getOperatorList() {
      try {
        this.markers.forEach((marker) => {
          this.map.removeOverlay(marker); // 百度地图API
          // 高德地图使用：marker.setMap(null);
        });
        this.markers = []; // 清空数组
        let data = await selectCompanyMachiner();
        console.log("获取机手列表回调", data);
        this.machinerVoList = data.data.machinerVoList || [];
        this.machinerVoList1 = data.data.runMachineUser || [];
        this.ldtpOrders = data.data.ldtpOrders || [];
        this.xmxxList = data.data.xmxxList || [];
        //机手列表流程
        // this.machinerVoList.forEach((item, index) => {
        //   if (item.status != 1) {
        //     this.machinerVoList.splice(index, 1);
        //   }
        // });
        this.machinerVoList.for
        // 设置type  1为农机 2为托管单 3为资源资产
        this.machinerVoList1.forEach((item, index) => {
          item.listType = 1;
        });
        this.ldtpOrders.forEach((item, index) => {
          item.listType = 2;
        });
        this.xmxxList.forEach((item, index) => {
          item.listType = 3;
        });
        let listData = [
          ...this.machinerVoList1,
          ...this.ldtpOrders,
          ...this.xmxxList,
        ];
        console.log("查看listData", listData);
        this.addMarkersNew(listData);

        // return;
        // if (this.machinerVoList1.length != 0) {
        //   this.addMachinerMarkers(this.machinerVoList1);
        // }
        // //托管单列表流程
        // if (this.ldtpOrders.length != 0) {
        //   this.addLdtpOrdersMarkers(this.ldtpOrders);
        // }
        // //自营土地列表流程
        // if (this.xmxxList.length != 0) {
        //   this.addXmxxListMarkers(this.xmxxList);
        // }
      } catch (error) {
        console.log("拉取数据错误", error);
      }
    },
    //绘制农机坐标点
    addMachinerMarkers(dataList) {
      console.log("查看处理后的农机列表", dataList);
      if (!dataList || !this.BMapGL) return;
      const BMapGL = this.BMapGL;
      const markerIcon = new BMapGL.Icon(this.icon, new BMapGL.Size(25, 30));
      markerIcon.setImageSize(new BMapGL.Size(25, 30));
      const coordMap = new Map();
      dataList.forEach((ele) => {
        if (ele.centerPoint == null) return;
        const point = ele.centerPoint.split(",");

        //处理偏移量
        const key = `${point[0]},${point[1]}`;
        const count = coordMap.get(key) || 0;
        coordMap.set(key, count + 1);

        //计算偏移后的点坐标
        let location = offsetLocation(count, point[0], point[1]);
        let pt = new BMapGL.Point(
          Number(location.lng) + 0.0001,
          Number(location.lat) + 0.0001
        );
        let marker = new BMapGL.Marker(pt, { icon: markerIcon });
        ele.infoType = "1"; //1是农机 2是托管单 3是自营土地
        marker.orderData = ele;
        marker.addEventListener("click", (e) => {
          console.log("点击坐标", e);
          this.showOrderInfo(e.target);
        });
        this.markers.push(marker);

        this.map.addOverlay(marker);
      });
    },
    //设置托管单坐标点
    addLdtpOrdersMarkers(dataList) {
      // console.log("查看托管单坐标列表入参", dataList);
      if (!dataList || !this.BMapGL) return;
      const BMapGL = this.BMapGL;
      //工作中托管单图标
      const markerIcon = new BMapGL.Icon(this.icon3, new BMapGL.Size(25, 30));
      markerIcon.setImageSize(new BMapGL.Size(25, 30));
      //空闲中托管单图标
      const markerIcon1 = new BMapGL.Icon(this.icon1, new BMapGL.Size(25, 30));
      markerIcon1.setImageSize(new BMapGL.Size(25, 30));
      const coordMap = new Map();
      dataList.forEach((ele) => {
        if (ele.centerPoint == null) return;
        const point = ele.centerPoint.split(",");
        //处理偏移量
        const key = `${point[0]},${point[1]}`;
        const count = coordMap.get(key) || 0;
        coordMap.set(key, count + 1);

        //计算偏移后的点坐标
        let location = offsetLocation(count, point[0], point[1]);
        let pt = new BMapGL.Point(
          Number(location.lng) + 0.0001,
          Number(location.lat) + 0.0001
        );
        let img = markerIcon;
        if (ele.isActive == true) {
          img = markerIcon1;
        }
        console.log("托管查看一下location", location);
        let marker = new BMapGL.Marker(pt, { icon: img });
        ele.infoType = "2"; //1是农机 2是托管单 3是自营土地
        marker.orderData = ele;
        marker.addEventListener("click", (e) => {
          console.log("点击坐标", e);
          this.showOrderInfo(e.target);
        });
        this.markers.push(marker);

        this.map.addOverlay(marker);
      });
    },
    // 设置自营土地坐标点
    addXmxxListMarkers(dataList) {
      // console.log("查看自营土地坐标列表入参", dataList);
      if (!dataList || !this.BMapGL) return;
      const BMapGL = this.BMapGL;
      //工作中托管单图标
      const markerIcon = new BMapGL.Icon(this.icon2, new BMapGL.Size(25, 30));
      markerIcon.setImageSize(new BMapGL.Size(25, 30));
      //空闲中托管单图标
      const markerIcon1 = new BMapGL.Icon(this.icon4, new BMapGL.Size(25, 30));
      markerIcon1.setImageSize(new BMapGL.Size(25, 30));
      const coordMap = new Map();
      dataList.forEach((ele) => {
        if (ele.centerPoint == null) return;
        const point = ele.centerPoint.split(",");
        //处理偏移量
        const key = `${point[0]},${point[1]}`;
        const count = coordMap.get(key) || 0;
        coordMap.set(key, count + 1);

        //计算偏移后的点坐标
        let location = offsetLocation(count, point[0], point[1]);
        let pt = new BMapGL.Point(
          Number(location.lng) + 0.0001,
          Number(location.lat) + 0.0001
        );
        let img = markerIcon;
        if (ele.isActive == true) {
          img = markerIcon1;
        }
        let marker = new BMapGL.Marker(pt, { icon: img });
        ele.infoType = "3"; //1是农机 2是托管单 3是自营土地
        marker.orderData = ele;
        console.log("自营土地坐标点", marker);
        marker.addEventListener("click", (e) => {
          console.log("点击坐标", e);
          this.showOrderInfo(e.target);
        });
        this.markers.push(marker);

        this.map.addOverlay(marker);
      });
    },
    //展示气泡
    showOrderInfo(marker) {
      // console.log("查看气泡入参marker", marker);
      if (this.currentInfoWindow) {
        this.map.closeInfoWindow(this.currentInfoWindow);
      }
      const info = marker.orderData;

      const ComponentClass = Vue.extend(orderInfoWindow);
      const instance = new ComponentClass({
        router,
        propsData: {
          info,
        },
      });
      instance.$on("windowChange", (newData) => {
        this.windowChange(newData);
        // 处理数据变化
      });
      const content = instance.$mount().$el;

      let height = 400;
      if (info.infoType == "1") {
        height = 150;
      } else if (info.infoType == "2") {
        height = 250;
      }
      if (info.infoType == "3") {
        height = 250;
      }
      this.currentInfoWindow = new BMapGL.InfoWindow(content, {
        width: 100,
        height: height,
        offset: new BMapGL.Size(0, -10),
      });
      this.currentInfoWindow.addEventListener("close", () => {
        // console.log("信息窗口关闭");
        localStorage.removeItem("machinistOrderInfo");
        let arr = this.machinerVoList;
        arr.forEach((item, index) => {
          item.operateId = null;
          item.status = null;
          item.copType = 1;
        });
        this.$emit("mapChange", {
          msg: "信息窗口关闭",
          data: arr,
        });
        // 执行关闭后的逻辑
      });
      this.currentInfoWindow.addEventListener("open", () => {
        console.log("信息窗口打开");
        // 执行关闭后的逻辑
      });
      this.map.openInfoWindow(this.currentInfoWindow, marker.getPosition());
      if (marker.orderData.infoType == "2") {
        //点击的是托管
        if (marker.orderData.operateId) {
          this.machinerVoList.forEach((item, index) => {
            // console.log("qweqeeq", item.id, marker.orderData.machinistId);
            if (item.id == marker.orderData.machinistId) {
              item.operateId = marker.orderData.operateId;
              item.status = 2;
              if (marker.orderData.isActive == true) {
                item.copType = 1;
              } else {
                item.copType = 2;
              }
            } else {
              item.operateId = "";
              item.status = null;
              if (marker.orderData.isActive == true) {
                item.copType = 1;
              } else {
                item.copType = 2;
              }
            }
          });
        } else {
          this.machinerVoList.forEach((item, index) => {
            item.operateId = "";
            item.status = null;
            if (marker.orderData.isActive == true) {
              item.copType = 1;
            } else {
              item.copType = 2;
            }
          });
        }
        this.$emit("mapChange", {
          msg: "点击托管单",
          data: this.machinerVoList,
        });
      } else {
        //点击的是资源资产
        // console.log("查看获取的数据qqqqqqqqqqqqqqqqqqqqqqqqqqqqq", JSON.parse(JSON.stringify(marker.orderData)))
        //operateId,分配记录的id，isActive是否在工作，农机的id
        if (marker.orderData.operateId) {
          this.machinerVoList.forEach((item, index) => {
            if (item.id == marker.orderData.machinistId) {
              item.operateId = marker.orderData.operateId;
              //在数组中添加isActive表示是否被选择，1选中
              item.isSelect = 1
              item.copType = 2

            } else {
              item.operateId = "",
                item.isSelect = 2
              item.copType = 2
            }
          })
          // console.log(this.machinerVoList, '查看获取的machinerVoList')
        }
        this.$emit("mapChange", {
          msg: "点击资源资产",
          data: this.machinerVoList,
        });
      }
    },
    windowChange(e) {
      console.log("windowChange", e);
      console.log("this.machinerVoList", this.machinerVoList);
      if (e.data.operateId) {
        this.machinerVoList.forEach((item, index) => {
          console.log("比对", item.id, e.data.machinistId);
          if (item.id == e.data.machinistId) {
            console.log("比对成功", item, e.data.machinistId);
            item.operateId = e.data.operateId;
            item.status = 2;
          } else {
            item.operateId = "";
            item.status = null;
          }
          item.copType = 2;
        });
      } else {
        this.machinerVoList.forEach((item, index) => {
          item.operateId = "";
          item.status = null;
          item.copType = 2;
        });
      }

      this.$emit("mapChange", {
        msg: "点击资源资产",
        data: this.machinerVoList,
      });
      // 重构机手列表传给我的机手组件
      // if(e.)
    },
    //新增坐标点
    addMarkersNew(dataList) {
      // console.log("查看dataList", dataList);
      console.log("查看托管单坐标列表入参", JSON.parse(JSON.stringify(dataList)));
      if (!dataList || !this.BMapGL) return;
      const BMapGL = this.BMapGL;

      //工作中托管单图标
      const markerIcon = new BMapGL.Icon(this.icon1, new BMapGL.Size(25, 30));
      markerIcon.setImageSize(new BMapGL.Size(25, 30));
      //空闲中托管单图标
      const markerIcon1 = new BMapGL.Icon(this.icon3, new BMapGL.Size(25, 30));
      markerIcon1.setImageSize(new BMapGL.Size(25, 30));
      // 农机图标
      const markerIcon2 = new BMapGL.Icon(this.icon, new BMapGL.Size(25, 30));
      markerIcon2.setImageSize(new BMapGL.Size(30, 40));
      // 工作中资源资产图标
      const markerIcon3 = new BMapGL.Icon(this.icon2, new BMapGL.Size(25, 30));
      markerIcon3.setImageSize(new BMapGL.Size(25, 30));
      // 空闲中资源资产图标
      const markerIcon4 = new BMapGL.Icon(this.icon4, new BMapGL.Size(25, 30));
      markerIcon4.setImageSize(new BMapGL.Size(25, 30));

      const coordMap = new Map();
      dataList.forEach((ele) => {
        if (ele.centerPoint == null) return;
        const point = ele.centerPoint.split(",");
        //处理偏移量
        const key = `${point[0]},${point[1]}`;
        const count = coordMap.get(key) || 0;
        coordMap.set(key, count + 1);

        //计算偏移后的点坐标
        let location = offsetLocation(count, point[0], point[1]);
        let pt = new BMapGL.Point(location.lng, location.lat);
        let img = markerIcon;
        if (ele.listType == 1) {
          img = markerIcon2;
        } else if (ele.listType == 2) {
          if (ele.machinistId) {
            img = markerIcon;
          } else {
            img = markerIcon1;
          }
        } else if (ele.listType == 3) {
          img = markerIcon3;
          // console.log(ele.userName,'查看获取的数据')
          if (ele.isActive == true) {
            img = markerIcon3;
          } else {
            img = markerIcon4;
          }

        }
        let marker = new BMapGL.Marker(pt, { icon: img });
        ele.infoType = ele.listType; //1是农机 2是托管单 3是自营土地
        marker.orderData = ele;
        marker.addEventListener("click", (e) => {
          this.showOrderInfo(e.target);
        });
        this.markers.push(marker);

        this.map.addOverlay(marker);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.MapBox {
  width: 100%;
  height: 900px;
  /* background-color: red; */
}

#allmap {
  width: 100%;
  height: 100%;
}
</style>
